var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ScalesListComponent',{attrs:{"loading":!_vm.scalesLoaded,"scales":_vm.scales,"id":_vm.$route.params.id,"(":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }